
    import { Component, Vue, Inject, Prop } from 'vue-property-decorator'
    import { mapState } from 'vuex'
    import validation from '@/app/common/helpers/validation'
    import { NotificationDispatcher } from "@/app/common/services/notification-dispatcher.service"
    import { VForm } from "@/app/common/types/v-form.type"
    import { Consumer } from "@/app/identity"
    import { GetPartnerDataCommand } from "@/app/inventory-form/commands/get-partner-data.command"

    @Component({
        computed: {
            ...mapState('auth', ['consumer'])
        }
    })
    export default class Retirement extends Vue {
        formData = {
            customer: [
                { inHomeAfterRetirement: null, netDisposableIncomeRetirement: null },
                { inHomeAfterRetirement: null, netDisposableIncomeRetirement: null }
            ]
        }
        @Inject() notificationDispatcher!: NotificationDispatcher
        @Inject() getPartnerDataCommand!: GetPartnerDataCommand
        @Prop({ default: () => ({}) }) readonly externalFormData!: any
        couple: Consumer|null = null
        consumer!: Consumer
        rules = validation
        async mounted() {
            this.couple = await this.getPartnerDataCommand.run()
            if (this.externalFormData.customer && this.externalFormData.customer.length >= 2) {
                this.formData.customer.forEach((item, index) => {
                    this.formData.customer[index] = { ...item, ...this.externalFormData.customer[index] }
                })
            }
        }
        get form() {
            return this.$refs.form as VForm
        }
        validate(): boolean {
            return this.form.validate()
        }
        goToPreviousStep() {
            this.$emit('changeStep', 3)
        }
        goToNextStep() {
            if (this.validate()) {
                this.$emit('updateData', this.formData)
                this.$emit('changeStep', 5)
            }
        }
    }
